import React, {FC} from "react";
import {withRouter} from "~/providers/with-router.tsx";

import CodesInfoForm from "~/components/code/accounting-code-form.tsx";


interface ComponentProps {
    title: string;
}

const UpdateCommonACPage: FC<ComponentProps> = ({title = "No Title"}: ComponentProps) => {
    return (
        <div className="d-flex flex-column nh-100">
            <h2 className="mb-3">{title}</h2>
            <div className="flex-grow-1 d-flex flex-column">
                <div className="mt-4">
                    <CodesInfoForm/>
                </div>
            </div>
        </div>
    );
}

export default withRouter(UpdateCommonACPage);
